module.exports = __webpack_public_path__ + "static/media/MY-MMU.098e30b8.png";